import React, { useMemo } from 'react';
import { ID_SITE } from '../../../../../conf/env';

import { Tooltip, CircularProgress, useTheme } from '@mui/material';
import TransactionButton from '@shared/components/TransactionButton';

const ID_SITE_CONST = Number(ID_SITE);

const BookButton = ({
  handleClick,
  index,
  label,
  disabled = false,
  tooltipText,
  loading = false,
  screenSize,
  clickedBuyButton = false,
  variant = 'buy',
  width = '60%',
}) => {
  const theme = useTheme();

  const tooltipTitle = useMemo(() => {
    if (!disabled) return '';
    if (ID_SITE_CONST === 2) {
      return `Comunicate con tu vendedor de confianza para finalizar el proceso de ${tooltipText}.`;
    }
    return `En este momento no es posible realizar la ${tooltipText}. Dirigite a tu sucursal más cercana`;
  }, [disabled, tooltipText]);

  const isButtonDisabled = loading || disabled;

  const circularSize = screenSize.width < 600 ? 20 : 28;

  return (
    <Tooltip
      disableTouchListener
      title={tooltipTitle}
      slotProps={{
        tooltip: {
          sx: theme => ({
            backgroundColor: '#ffff',
            color: theme.palette.text.secondary,
            border: `2px solid ${theme.palette.grey[700]}`,
            textAlign: 'center',
            fontSize: 14,
            padding: '5px 10px',
            margin: 0,
          }),
        },
      }}
    >
      <div style={{ width: '100%' }}>
        <TransactionButton
          id={`buyButton${index}`}
          onClick={handleClick}
          disabled={isButtonDisabled}
          variant={variant}
          width={width}
        >
          {clickedBuyButton && loading ? (
            <CircularProgress sx={{ color: theme.text1 }} size={circularSize} />
          ) : (
            label
          )}
        </TransactionButton>
      </div>
    </Tooltip>
  );
};

export default BookButton;
